/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, April 2022
 * @flow
 */

import React from 'react';
import classNames from 'classnames';
import classes from './CheckDetails.module.css';

const Discount = ({ data, currency }) => {
  const { name, price } = data || {};
  const amount = (price && !isNaN(+price)) ? (+price).toFixed(2) : '';

  return (
    <div className={classes.itemContainer}>
      <div className={classes.rowSpaceBetween}>
        <div className={classes.nameAndPrice}>
          <span className={classNames(`${classes.checkCellView}`, `${classes.name}`)}>
            {name}
          </span>
          <span className={classNames(`${classes.checkCellView}`, `${classes.price}`)}>
            {`${currency}${amount}`}
          </span>
        </div>
      </div>
    </div>
  );
};

export default Discount;
